import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { SlotsController } from '@shared/src/controllers/address/slots/slots.controller';
import { NomsHardman } from '@shared/src/controllers/NomsHardman';
import { PhaseController } from '@shared/src/controllers/route/phase/phase.controller';
import { HTags } from '@shared/src/datatypes/HTags';
import { PhaseSlotDto } from '@shared/src/dtos/phase/slot/PhaseSlotDto';
import { RouteCardItemDto } from '@shared/src/dtos/route/RouteCardItemDto';
import { HomeController, ShipmentController } from '@shared/src/public-api';

@Component({
  selector: 'shared-route-strip-properties-component',
  templateUrl: './shared.route.strip.properties.component.html',
  styleUrls: ['./shared.route.strip.properties.component.scss'],
})
export class SharedRouteStripPropertiesComponent {

  public useIonic: boolean = false;

  constructor(private el: ElementRef, private renderer: Renderer2, protected homeController: HomeController, protected slotsController: SlotsController, protected phaseController: PhaseController, protected shipmentController: ShipmentController) {
  }
  public notready = false;
  public delayed = false;
  public urgent = false;
  public problem = false;
  public algunaCosaAMostrar = false;

  private _route: RouteCardItemDto | null = null;
  @Input()
  set route(value: RouteCardItemDto) {
    if (this._route === value)
      return;
    this._route = value;
    this.wellcomeRoute();
  }
  get route(): RouteCardItemDto | null {
    return this._route;
  }
  private wellcomeRoute() {
    if (this.route == null)
      this.wellComeTags(null);
    else
      this.wellComeTags(HTags.buildFromDto(this.route.internalTags));
  }


  private _phaseslot: PhaseSlotDto | null = null;
  @Input() public set phaseslot(value: PhaseSlotDto) {
    if (this._phaseslot === value)
      return;
    this._phaseslot = value;
    this.wellcomePhaseSlot()
  }
  public get phaseslot(): PhaseSlotDto | null {
    return this._phaseslot;
  }
  private wellcomePhaseSlot() {
    if (this.phaseslot == null)
      this.wellComeTags(null);
    else
      this.wellComeTags(HTags.buildFromDto(this.phaseslot.routeInternalTags));
  }
  public tags: HTags | null = null;
  private wellComeTags(routeInternalTags: HTags | null) {
    this.tags = routeInternalTags;
    if (routeInternalTags == null) {
      this.algunaCosaAMostrar = false;
      return;
    }

    this.notready = HTags.contains(routeInternalTags, NomsHardman.NOTREADY);
    this.delayed = HTags.contains(routeInternalTags, NomsHardman.DELAYED);
    this.problem = HTags.contains(routeInternalTags, NomsHardman.PROBLEM);
    this.urgent = HTags.contains(routeInternalTags, NomsHardman.URGENT);

    this.algunaCosaAMostrar = this.notready || this.delayed || this.problem || this.urgent;
    if (!this.algunaCosaAMostrar)
      this.hide();
    else
      this.show();
  }

  public hide() {
    this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
  }
  public show() {
    this.renderer.removeStyle(this.el.nativeElement, 'display');
  }

  public pretty(value: any) {
    return JSON.stringify(value);
  }
}
